<template>
  <div class="auth-container">
    <p>{{ $t('auth.account_verification') }}</p>
  </div>
</template>

<script>
import axios from 'axios'
import { EventBus } from '../../event-bus.js'

export default {
  name: 'AccountVerification',

  created () {
    this.verifyToken(this.$route.params.token)
  },

  methods: {
    verifyToken (token) {
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/auth/verify/' + token)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.$cookies.set('access_token', response.data.access_token)
            EventBus.$emit('tokenSet', response.data.access_token)
            axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.access_token
            this.$emit('onAccountActivate', true)
            this.$router.push({ name: 'auth.account-active' })
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    }
  }
}
</script>
